export enum Role {
  // OGI roles
  OGI_Super_Administrator = 'OGI_Super_Administrator',
  OGI_Laboratory_Administrator = 'OGI_Laboratory_Administrator',
  // General roles
  Super_User = 'Super_User',
  Lab_Administrator = 'Lab_Administrator',
  Edit_Access_User = 'Edit_Access_User',
  Run_Access_User = 'Run_Access_User',
  Read_Access_User = 'Read_Access_User',
}

export const OGI_SUPER_ADMIN_ONLY: Role[] = [Role.OGI_Super_Administrator];

export const OGI_ADMIN_ROLE_LIST: Role[] = [
  Role.OGI_Super_Administrator,
  Role.OGI_Laboratory_Administrator,
];

export const SUPER_ADMIN_ROLE_LIST: Role[] = [
  Role.OGI_Super_Administrator,
  Role.Super_User,
];

export const OGI_ADMIN_AND_SUPER_USER_ROLE_LIST: Role[] = [
  ...OGI_ADMIN_ROLE_LIST,
  Role.Super_User,
];

export const LAB_ADMIN_ROLE_LIST: Role[] = [
  ...OGI_ADMIN_AND_SUPER_USER_ROLE_LIST,
  Role.Lab_Administrator,
];

export const EDIT_ACCESS_ROLE_LIST: Role[] = [
  ...LAB_ADMIN_ROLE_LIST,
  Role.Edit_Access_User,
];

export const RUN_ACCESS_ROLE_LIST: Role[] = [
  ...EDIT_ACCESS_ROLE_LIST,
  Role.Run_Access_User,
];

export enum RoleEnum {
  // OGI roles
  OGI_Super_Administrator = 1,
  OGI_Laboratory_Administrator = 2,
  // General roles
  Super_User = 3,
  Lab_Administrator = 4,
  Edit_Access_User = 5,
  Run_Access_User = 6,
  Read_Access_User = 7,
}
